export default function (trigger, triggerVideoSelector, nextVideoSelector) {
  const nextMedia = nextVideoSelector;
  let timeLeave;

  if ('currentTime' in triggerVideoSelector) {
    timeLeave = triggerVideoSelector.currentTime;
  }

  if ('currentTime' in nextMedia) {
    nextMedia.currentTime = timeLeave + 0.3;
    nextMedia.play();
  }
}
